import { render } from "./Guess.vue?vue&type=template&id=2f99ffd8&ts=true"
import script from "./Guess.vue?vue&type=script&lang=ts"
export * from "./Guess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__